import './Toggle.css';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

/**
 * Toggle switch component
 */
function Toggle({ checked, onChange, label, disabled = false }: ToggleProps): JSX.Element {
  return (
    <label className={`toggle ${disabled ? 'toggle--disabled' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="toggle-switch"></span>
      {label && <span className="toggle-label">{label}</span>}
    </label>
  );
}

export default Toggle;
